import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Typography } from "antd";
import { context } from "../../context/context";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const FeedBackFormStepOne = () => {
    const [form] = Form.useForm();
    // state
    const [isEditSelected, setIsEditSelected] = useState(false);
    const [dateRange, setDateRange] = useState([]);
    const [inputTitleStyle, setInputTitleStyle] = useState({
        width: "100%",
        outline: "0",
    });
    // context
    const {
        selectedFeedBackId,
        setFeedBackStartDate,
        setFeedBackEndDate,
        setFeedBackStartText,
        setFeedBackEndText,
        feedBackEndDate,
        feedBackEndText,
        feedBackStartDate,
        feedBackStartText,
        setFeedBackTitle,
        feedBackTitle,
    } = useContext(context);
    // useEffect
    useEffect(() => {
        if (selectedFeedBackId) {
            setIsEditSelected(true);
            setDateRange([feedBackStartDate, feedBackEndDate]);
        } else {
            setDateRange([new Date(), new Date()]);
        }
    }, []);

    // functions
    const handleChangeDate = (value) => {
        setFeedBackStartDate(value[0]?.toDate?.().toString());
        setFeedBackEndDate(value[1]?.toDate?.().toString());
        setDateRange(value);
    };
    const handleChangeStartText = (e) => {
        setFeedBackStartText(e.target.value);
    };
    const handleChangeEndText = (e) => {
        setFeedBackEndText(e.target.value);
    };

    return (
        <div
            style={{
                direction: "rtl",
                display: "flex",
                gap: "15px",
                margin: "15px",
            }}
        >
            <Form
                layout="vertical"
                form={form}
                name="control-hooks"
                style={{
                    width: "100%",
                }}
            >
                <Form.Item name="عنوان" label="عنوان" style={{ width: "100%" }}>
                    <h4 style={{ textAlign: "right", display: "none" }}>
                        در حال ویرایش {feedBackStartText}
                    </h4>
                    <input
                        style={inputTitleStyle}
                        className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                        placeholder="عنوان"
                        value={selectedFeedBackId ? feedBackTitle : null}
                        onChange={(e) => {
                            setFeedBackTitle(e.target.value);
                        }}
                        onFocus={() => {
                            const updatedStyle = {
                                ...inputTitleStyle,
                                outline: "1px solid #48D1CC",
                                borderColor: "#48D1CC",
                            };
                            setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                        }}
                        onBlur={() => {
                            const updatedStyle = {
                                ...inputTitleStyle,
                                outline: "",
                                borderColor: "",
                            };
                            setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                        }}
                        onMouseEnter={() => {
                            const updatedStyle = {
                                ...inputTitleStyle,
                                borderColor: "#48D1CC",
                            };
                            setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                        }}
                        onMouseLeave={() => {
                            const updatedStyle = {
                                ...inputTitleStyle,
                                borderColor: "",
                            };
                            setInputTitleStyle(updatedStyle); // assuming setInputStyle is a setter function to update inputStyle
                        }}
                    ></input>
                </Form.Item>
                <Form.Item
                    name="متن شروع"
                    label="متن شروع"
                    style={{ width: "100%" }}
                >
                    <h4 style={{ textAlign: "right", display: "none" }}>
                        در حال ویرایش {feedBackStartText}
                    </h4>
                    <textarea
                        className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                        type="text"
                        value={isEditSelected ? feedBackStartText : null}
                        onChange={handleChangeStartText}
                        placeholder="متن را وارد کنید"
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name="متن پایان"
                    label="متن پایان"
                    style={{ width: "100%" }}
                >
                    <h4 style={{ textAlign: "right", display: "none" }}>
                        در حال ویرایش {feedBackEndText}
                    </h4>
                    <textarea
                        className="ant-input css-dev-only-do-not-override-lzp0br css-dev-only-do-not-override-lzp0br"
                        type="text"
                        value={isEditSelected ? feedBackEndText : null}
                        onChange={handleChangeEndText}
                        placeholder="متن را وارد کنید"
                        style={{
                            width: "100%",
                            padding: "0.5rem",
                        }}
                    />
                </Form.Item>
                <Form.Item
                    name="تاریخ"
                    label="تاریخ شروع و پایان"
                    style={{ width: "100%" }}
                >
                    <div style={{ display: "none", gap: "2rem" }}>
                        <Typography.Paragraph>
                            {feedBackStartDate}
                        </Typography.Paragraph>
                        <Typography.Paragraph>
                            {feedBackEndDate}
                        </Typography.Paragraph>
                    </div>
                    <DatePicker
                        value={dateRange}
                        onChange={handleChangeDate}
                        range
                        dateSeparator=" تا "
                        plugins={[<DatePanel position="right" />]}
                        calendar={persian}
                        locale={persian_fa}
                        calendarPosition="bottom-right"
                    />
                </Form.Item>
            </Form>
        </div>
    );
};

export default FeedBackFormStepOne;
